import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { faqQueries } from '@/services/faq/faq.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useDeleteReviewAndRatings = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncReviewAndRatingsStatus } = useMutation('deleteUserRatings', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: [...faqQueries.all(), 'review-and-ratings'] });
      toast.success(res.message);
      await revalidate(['clubReview', 'all']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsyncReviewAndRatingsStatus };
};

export default useDeleteReviewAndRatings;
